/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Mar 10 2025
 **/

import PlayerIndicator from "./PlayerIndicator";
import NetworkPlayerIndicators from "./NetworkPlayerIndicators";
import { HTMLAttributes } from "react";

export default function Indicators(props: HTMLAttributes<HTMLDivElement>) {
	return (
		<div css={{ position: "relative" }} {...props}>
			<PlayerIndicator />
			<NetworkPlayerIndicators />
		</div>
	);
}
